import { gql } from '@apollo/client/core';

export const UPDATE_MY_NOTE = gql`
  mutation UpdateMyNote {
    updateMyNote {
      user {
        data {
          attributes {
            notes {
              data {
                attributes {
                  cavente
                  nbvente
                  venterebond
                  moyennegenerale
                  qtevente
                  qteca
                  qtepro
                  qterebond
                  qtequiz
                }
              }
            }
          }
        }
      }
    }
  }
`;
